module.exports = __webpack_public_path__ + "static/media/retirement-object-1-1-0.b6ef533c.png";